export default __webpack_public_path__ + "static/media/align_horizontal_left-B.e536b1f7.svg";